<template>
    <ed-modal
        :show="showModal"
        @close="$emit('close')"
        @validate="onSave"
        :validation="true"
        type='medium'
        title="Edit AP File Template"
        primaryButton="SAVE"
        secondary-button="CANCEL"
        :closeOnEsc="true"
    >
        <div
            class="content form-group"
            slot="body"
        >
            <ed-form class="col-md-12" :submit-visible="false">
                <section class="col-md-5 no-pad">
                </section>
                <section class="col-md-7 no-pad pull-right">
                    <div class="row">
                        <label>AP File Template Name</label>
                        <p>{{model.Name}}</p>
                    </div>
                    <div class="row">
                      <ed-select-list
                        field-label='Divisions'
                        v-model='divisions'
                        :endpoint='api.$.FundingInvoiceAndApSetting.getDivisionsForAPFileTemplates'
                        track-by='DivisionId'
                        label='DivisionName'
                        :params='payload'
                        required
                        :error="doDisplayDivisionsError"
                        :helptip-header="doDisplayDivisionsError && 'Error' || ''"
                        :helptip-body="doDisplayDivisionsError && 'Please select a Division' || ''"
                        @select='selectDivision'
                      />
                    </div>
					<div class="row">
                      <ed-select-list
                        v-if='doDisplayBUSelect'
                        field-label='Business Units'
                        v-model='businessUnits'
                        :endpoint='api.$.FundingInvoiceAndApSetting.getBusinessUnitsForAPFileTemplates'
                        track-by='Id'
                        label='Name'
                        :params='payload'
                        required
                        :error="doDisplayBUError"
                        :helptip-header="doDisplayBUError && 'Error' || ''"
                        :helptip-body="doDisplayBUError && 'Please select a Business Unit' || ''"
                        @select='selectBusinessUnit'
                      />
                    </div>
                </section>
                <div class="clear"></div>
            </ed-form>
        </div>
    </ed-modal>
</template>

<script>
export default {
  props: {
    model: Object,
    showModal: Boolean
  },
  data() {
    return {
      doDisplayEmailError: false,
      doDisplayDivisionsError: false,
      doDisplayBUSelect: this.model.HasAPSettingsByBU,
      doDisplayBUError: false,
      divisions: this.model.Divisions,
      businessUnits: this.model.BusinessUnits,
      payload: {AuditFileTemplateId: this.model.AuditFileTemplateId || 0}
    }
  },
  methods: {
    isValid() {
      var result = true
      if (this.divisions && this.divisions.length <= 0) {
        this.doDisplayDivisionsError = true
        result = false
      }
      return result
    },

    onSave() {
      if (!this.isValid()) return
      let AuditFileTemplateDTO = {
        AuditFileTemplateId: this.model.AuditFileTemplateId,
        Name: this.model.Name
      }
      let param = {
        AuditFileTemplateDTO,
        DivisionsIds: this.divisions,
        BusinessUnitIds: this.businessUnits
      }
      this.api.post(this.api.$.FundingInvoiceAndApSetting.updateAPFileTemplate, param)
      .then(response => {
        this.$emit('save')
      })
    },
    selectDivision() {
      this.doDisplayDivisionsError = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/_modules/FundingInvoiceAndAPSettings/APFileTemplates/EditAPFileTemplate.vue